<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/105CXR0/tc-custom/9781398487086.jpg?1705766067588" alt="This image is the cover for the book The Unknown Battles That Lie Beyond the Grave"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Unknown Battles That Lie Beyond the Grave
      </h1>
      <p class="bookDescription body article font2">
        <p>The red-hot saucy chatter was that on the day Manku rescued Joanna from the sewer hole, she wasn’t wearing any knickers. It was therefore alleged the four men got more than they bargained for during the rescue mission. Trump suddenly woke up as though from a slumber. He was no longer in the rough and choppy waters. He soon realised that his body was different and that he wasn’t alone. As he stood there in awe and disbelief, suddenly, he was surrounded by seven individuals adorned in bodies similar to his. He responded that for his first mission, he was inclined to pick Combat Ghosts from one class only, from the class of the dead evil men and women. It was just the beginning. He was in for a rude shock!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sylvester Alex Bosch
      </h2>
      
      <p class="authorDescription body article">A loving husband and father, a CA, and a financial leader in his sector. Sylvester Alex Bosch’s view on life is drawn from diverse cultural backgrounds. He is a strong believer in philosophy, mystery, fantasy, history and religion. He believes nothing just happens; that we all came from somewhere; are here for a reason and season, and when our time here is up, we continue to exist in a new dimension that includes fighting mysterious battles we barely knew existed during our life time. Success in these unknown battles that lie beyond the grave is predicated on diligence, shrewdness, perseverance, humility and excellence.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?abce42f4